import React from 'react';
import { css } from '@emotion/react';

import { quarterSpacing } from 'styles/global_defaults/scaffolding';
import { genAIGradientType4 } from 'styles/global_defaults/colors';
import ConversationModalHeader from './header';
import ConversationBody from './conversation-body';

const ConversationModalContent = () => {
  const styles = css`
    border-top: ${quarterSpacing}px solid transparent;
    border-image-source: ${genAIGradientType4};
    border-image-slice: 1;
  `;

  return (
    <div css={styles} className='position-relative d-flex flex-column'>
      <ConversationModalHeader />
      <ConversationBody />
    </div>
  );
};

export default ConversationModalContent;
